import { useState, useRef, useEffect } from 'react';

import InsiderSvc from '../../../../../services/dbServices/InsiderSvc';

import ChartBox from '../ChartBox';

const ChartBoxHolder = (props) => {
  const { companyNumber } = props;

  let mounted = true;
  const initialized = useRef(false);
  const [firstChartData, setfirstChartData] = useState({
    loading: true,
    data: [],
  });

  const callAPI = () => {
    const params = {
      time_period: 'all',
      company_number: companyNumber,
    };

    InsiderSvc.getCompanyGraphsShares(params)
      .then((res) => {
        if (!mounted) {
          return;
        }

        initialized.current = true;

        setfirstChartData({
          loading: false,
          data: res || [],
        });
      });
  };

  useEffect(() => {
    setTimeout(() => {
      callAPI({ pageSize: 10, currentPage: 1 });
    }, 200);

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div>
      <ChartBox
        chartType="price"
        title="Price Per Share (GBP)"
        companyNumber={companyNumber}
        firstChartData={firstChartData}
      />
      <ChartBox
        chartType="marketCap"
        title="Last Round Valuation"
        companyNumber={companyNumber}
        firstChartData={firstChartData}
      />
    </div>
  );
};

export default ChartBoxHolder;
